import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../auth/auth.guard';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RoleListComponent } from './components/role-list/role-list.component';
import { RoleFormComponent } from './components/role-form/role-form.component';
import { RoleResolver } from './resolvers/role.resolver';
import { RoleListResolver } from './resolvers/role-list.resolver';
import { AuthorityListResolver } from './resolvers/authority-list.resolver';
import { RoleDetailComponent } from './components/role-detail/role-detail.component';
import { RoleSearchComponent } from './components/role-search/role-search.component';


const routes: Routes = [
    {
        path: '',
        component: RoleListComponent,
        canActivate: [AuthGuard],
        resolve: {
            roleListResolverResponse: RoleListResolver,
        }
    },
    {
        path: 'new',
        component: RoleFormComponent,
        canActivate: [AuthGuard],
        resolve: {
            authorityListResolverResponse: AuthorityListResolver,
        }
    },
    {
        path: ':roleId/detail',
        component: RoleDetailComponent,
        canActivate: [AuthGuard],
        resolve: {
            roleResolverResponse: RoleResolver
        }
    },
    {
        path: ':roleId/edit',
        component: RoleFormComponent,
        canActivate: [AuthGuard],
        resolve: {
            roleResolverResponse: RoleResolver,
            authorityListResolverResponse: AuthorityListResolver,
        }
    }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        SharedModule

    ],
    declarations: [RoleListComponent, RoleFormComponent, RoleDetailComponent, RoleSearchComponent],
    exports: [],
    entryComponents: []
})

export class RoleModule {
    static forRoot() {
        return {
            ngModule: RoleModule
        };
    }
}
